"use client";
import classNames from "classnames";
import { debounce } from "lodash";
import { useEffect, useRef, useState } from "react";
import styles from "./LegalItem.module.scss";
import { Title } from "components/typography/Title";
import { EditorContent } from "../../pages/article/EditorContent";

export type LegalItemProps = {
  id: string;
  heading: string;
  content: string;
};

const LegalItem = ({ id, heading, content }: LegalItemProps) => {
  const contentWrapper = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const openRef = useRef(open);

  const parsedContent = JSON.parse(content);
  openRef.current = open;

  const toggleItem = () => {
    if (!contentWrapper.current) return;
    if (window.matchMedia("(max-width: 576px)").matches) {
      if (open) {
        contentWrapper.current.style.maxHeight = "0";
      } else {
        contentWrapper.current.style.maxHeight = contentWrapper.current.scrollHeight + "px";
      }
    } else {
      contentWrapper.current.style.maxHeight = "none";
    }

    setOpen(!open);
  };

  const checkResize = debounce(() => {
    if (!contentWrapper.current) return;
    if (window.matchMedia("(max-width: 576px)").matches) {
      if (openRef.current) {
        contentWrapper.current.style.maxHeight = contentWrapper.current.scrollHeight + "px";
      } else {
        contentWrapper.current.style.maxHeight = "0";
      }
    } else {
      contentWrapper.current.style.maxHeight = "none";
    }
  }, 50);

  useEffect(() => {
    window.addEventListener("resize", checkResize);

    return () => {
      window.removeEventListener("resize", checkResize);
    };
  }, [checkResize]);

  return (
    <div
      className={classNames(styles.legalItem, {
        [styles.legalItemOpen]: open,
      })}
    >
      <div id={id} className={styles.anchor}></div>
      <div className={styles.headingWrap} onClick={toggleItem}>
        <Title level={2} className={styles.heading} html={heading} />
        {/*<Icon icon="angle-down" className={styles.icon} />*/}
      </div>
      <div ref={contentWrapper} className={styles.contentWrapper}>
        <div className={styles.content}>
          <div className={styles.contentInner}>
            <EditorContent data={parsedContent} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalItem;
